import script from "./PlayerInformationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerInformationModal.vue?vue&type=script&setup=true&lang=ts"

import "./PlayerInformationModal.vue?vue&type=style&index=0&id=13c871f0&lang=scss"

const __exports__ = script;

export default __exports__